import { combineReducers } from 'redux';
import TurneroAsignacionesReducer from './Turnero.Asignaciones.Reducer';
import TurneroConsultoriosReducer from './Turnero.Consultorios.Reducer';
import TurneroHistoriaClinicaReducer from './Turnero.HistoriaClinica.Reducer';
import TurneroLlamadosReducer from './Turnero.Llamados.Reducer';
import TurneroMedicosReducer from './Turnero.Medicos.Reducer';
import TurneroPacientesReducer from './Turnero.Pacientes.Reducer';
import TurneroPrefacturadorReducer from './Turnero.Prefacturador.Reducer';
import TurneroSectoresReducer from './Turnero.Sectores.Reducer';
import TurneroSedesReducer from './Turnero.Sedes.Reducer';
import TurneroVideosReducer from './Turnero.Videos.Reducer';
import TurneroQueueDisplayScreenReducer from './Turnero.QueueDisplayScreen.Reducer';

export const CombinedTurneroReducer = combineReducers({
    Asignaciones: TurneroAsignacionesReducer,
    Consultorios: TurneroConsultoriosReducer,
    HistoriaClinica: TurneroHistoriaClinicaReducer,
    Llamados: TurneroLlamadosReducer,
    Medicos: TurneroMedicosReducer,
    Pacientes: TurneroPacientesReducer,
    Prefacturador: TurneroPrefacturadorReducer,
    Sectores: TurneroSectoresReducer,
    Sedes: TurneroSedesReducer,
    Videos: TurneroVideosReducer,
    QueueDisplayScreen: TurneroQueueDisplayScreenReducer
});
